module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.component_class,
    style: (_vm.custom_style),
    on: {
      "mouseenter": function($event) {
        _vm.is_hover = true
      },
      "mouseleave": function($event) {
        _vm.is_hover = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('InputLabel', {
    attrs: {
      "label": _vm.label
    }
  }), _vm._v(" "), _c('InputField', {
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "format": _vm.format,
      "reg": _vm.reg,
      "verify": _vm.verify,
      "value": _vm.value != null ? _vm.value : _vm.val,
      "autosize": _vm.autosize,
      "rows": _vm.rows,
      "no_padding": !_vm.with_border
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": function($event) {
        _vm.blurHandler(_vm.is_edited)
      },
      "enter": _vm.enterHandler,
      "input": _vm.inputHandler,
      "change": function($event) {
        _vm.$emit('change', arguments[0])
      },
      "verify": _vm.verifyHandler
    }
  }), _vm._v(" "), _c('InputTip', {
    attrs: {
      "tip": _vm.err_tip,
      "position": _vm.type === 'textarea' ? 'top' : 'middle',
      "verify": _vm.verify,
      "is_error": _vm.is_error,
      "is_correct": _vm.is_correct
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ea9646e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input/Input.vue
// module id = 672
// module chunks = 0